// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.product-attribute-bulk-form[data-v-1cac157f] {\n  min-height: calc(100vh - 80px);\n}\n.product-attribute-bulk-spreadsheet[data-v-1cac157f] {\n  width: 100%;\n}\n.product-attribute-bulk-dialog[data-v-1cac157f] .el-dialog__body {\n  padding: 0;\n}\n", ""]);
// Exports
module.exports = exports;
